import _ from 'lodash';

class TableGridModalLinkCellController {
  constructor(tableService,$q) {
    this.name = 'tableGridModalLinkCell';
    this.$q = $q;
    this.tableService = tableService;
    this.isRequestFailure = false;
  }

  fetchOrSetData(scope, modalOptions) {
    let hasValidUri = modalOptions.uri;
    if (hasValidUri) {
      return this.fetchData(scope, modalOptions.uri, modalOptions.uriFieldMappings);
    } else
      return this.setData(scope, modalOptions);
  }

  fetchData(scope, uri, uriFieldMappings) {
    let updatedUri = this.rebuildUriWithData(scope, uri, uriFieldMappings);
    return this.tableService.getTableData(updatedUri);
  }

  setData(scope, modalOptions) {
    let deferred = this.$q.defer();

    let valueToDisplay = scope.row[modalOptions.valueToDisplay];
    let data = {
      content: []
    };

    if (valueToDisplay) {
      data.content.push(valueToDisplay);
    }
    deferred.resolve({data:data});

    return deferred.promise;
  }

  rebuildUriWithData(scope, uri, uriFieldMappings) {
    let updatedUri = '';
    let valueToReplace = '';
    let uriParts = uri.replace(/^\//,'').split('/');

    _.each(uriParts, (uriPart) => {
      valueToReplace = _.findKey(uriFieldMappings, (value) => {
        return value === uriPart;
      });
      updatedUri = valueToReplace ? `${updatedUri}/${scope.row[valueToReplace]}` : `${updatedUri}/${uriPart}`;
    });
    return updatedUri;
  }

  getModalLinkText() {
    this.hasData = this.data && this.data.content.length > 0;
    return this.hasData ? this.modalLinkText.hasData : this.modalLinkText.noData;
  }

  showModal() {
    if (this.hasData) {
      this.modalLoaderService.show(this.modalComponent, {
        data: this.data
      }, this.modalContentClass);
    }
  }
}

TableGridModalLinkCellController.$inject = ['tableService','$q'];

export default TableGridModalLinkCellController;


// WEBPACK FOOTER //
// ./app/components/tableGridModalLinkCell/tableGridModalLinkCell.controller.js